// The standard regulatory footer from the dwlf-compliance guardrails (DWLF-534), for surfaces that
// carry the guardrails' wording as is. Which surfaces carry it is recorded in ARCHITECTURE.md (the
// DWLF-145 standing decision).
export const REGULATORY_FOOTER = 'Not a forecast and not a trading signal. Does not take account of your positions.';

// The front door's variant: the standard footer without "and not a trading signal", because the front
// door keeps "signal" off its copy entirely, disclaimer included (DWLF-145; Andy, 2026-10-27).
// Derived, so a change to the standard wording reaches the front door too.
export const FRONT_DOOR_FOOTER = REGULATORY_FOOTER.replace(' and not a trading signal', '');
